export default "__VITE_ASSET__W_7CtkGN__"